<template>
    <div class="music--form-container">
        <data-container>
            <template #content>
                <SubscriberPlanForm
                    title="New Subscription Plan"
                    @submit="submit"
                    @cancel="$router.push({ name: 'SubscriberPlansList' })" />
            </template>
        </data-container>
    </div>
</template>

<script>
import DataContainer from '@/components/DataContainer'
import SubscriberPlanForm from '@/components/SubscriberPlanForm'
import subscriberPlan from '@/store/subscriber-plan/app.js'
import { mapFields } from 'vuex-map-fields'

export default {
	methods: {
		submit () {
			const { dateFormatter } = this.$options.filters
			const form = new FormData()
			Object.keys(this.form).forEach(key => {
				let value = this.form[key]
				value = key.includes('discount_duration') ? dateFormatter(value, 'YYYY-MM-DD') : key === 'billing_cycle' ? value.toLowerCase() : value
				value = key === 'name' ? value.trim() : value
				form.set(key, value)
			})

			this.$store.dispatch('subscriberPlan/create', { form, callback: () => this.$router.push({ name: 'SubscriberPlansList' }) })
	    }
	},
	components: {
		DataContainer,
		SubscriberPlanForm
	},
	computed: {
		...mapFields('subscriberPlan', ['form'])
	},
	beforeCreate () {
		if (!this.$store.hasModule('subscriberPlan')) {
			this.$store.registerModule('subscriberPlan', subscriberPlan)
		}
	}
}
</script>

<style lang="scss" scoped>
.data-container {
    width: 480px;
    height: auto;
}

.music--form-container {
    padding: 1.5em;
}
</style>
